import { DetailAndAllocateForEstimateComponent } from "../../../components/SupportSystem/SupportForm/current/DetailAndAllocateForEstimateComponent";
import { NavbarSupportSystem } from "../../../components/share/NavbarSupportSystem";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";


export function DetailAndAllowcateForEstimateContainer() {
    const titleName = "ระบบการให้เงินช่วยเหลือหรืออุดหนุนกองทุนพัฒนาฝีมือแรงงาน";
    return(
        <div className="page-container bg-landing">
            <NavbarSupportSystem />
            <HeadTitle title={titleName} />
            <DetailAndAllocateForEstimateComponent/>
            <Footer />
        </div>   
        // 
    )
    
}